import { getUserNeedsProfileSetupFromToken } from 'api';
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GoogleSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const needsProfileSetup = getUserNeedsProfileSetupFromToken(token);

    if (token && needsProfileSetup) {
      localStorage.setItem('token', token);
      navigate('/redaguoti-profili', {
        state: {
          needsProfileSetup: true,
        },
      });
    } else if (token && !needsProfileSetup) {
      localStorage.setItem('token', token);
      navigate(location.state?.to || '/info');
    } else {
      navigate('/prisijungimas');
    }
  }, [location, navigate]);

  return null; // Or show spinner
};

export default GoogleSuccess;
